<template>
  <div>
    <CheckWire
      v-if="isCheckWireModalVisible"
      :closeAction="modalToAddNewFundingSourceHasBeenClosed" />

    <div id="panelChart9" class="panel panel-default">
      <div v-if="!showDwollaComponent">
        <div class="panel-title top-margin">Bank accounts</div>

        <div class="line-separator"></div>

        <div class="row bottom-margin button-row">
          <div class="col-lg-2 button-col">
            <button type="button"
              class="btn btn-default btn-lg top-margin"
              @click="openModalToAddNewFundingSource">
              Add check or Wire/ACH
            </button>
          </div>

          <div class="col-lg-2 button-col">
            <button
              type="button"
              @click="addAccount()"
              class="btn btn-default btn-lg addButton top-margin"
            >
              Add a bank account
            </button>
          </div>

          <div class="col-lg-6">
          </div>
        </div>

        <div class="row" v-if="fundingSources.length === 0">
          <div class="col-lg-12">
            <div class="alert alert-info alert-dismissible" role="alert">
              No bank accounts were found.
            </div>
          </div>
        </div>

        <!-- Desktop Table View -->
        <div v-if="fundingSources.length > 0 || showFundingTable"
          v-bind:class="{'table-fixed-header--md cols-4': fundingSources.length > 6, 'table-responsive': true, 'bottom-margin': true, 'desktop-table': true}">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="text-left">Bank name</th>
                <th class="text-left">Account name</th>
                <th class="text-left">Type</th>
                <th class="text-center">Default</th>
                <th class="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fundingSource, index) in fundingSources" :key="index">
                <td class="text-left">{{fundingSource.bankName ? fundingSource.bankName : '-----'}}</td>
                <td class="text-left">{{fundingSource.name}}</td>
                <td class="text-left">{{formatType(fundingSource.type, 'investor')}}</td>
                <td class="text-center">
                  <div :class="{ 'radio-item': true, 'radio-item-unselected': fundingSource.id.toString() !== currentDefaultFundingSourceId }">
                    <input type="radio"
                      :id="fundingSource.id"
                      :for="fundingSource.id"
                      :value="fundingSource.id.toString()"
                      v-if="fundingSource.status === 'verified'"
                      @click="showDefaultFundingSourceConfirmationModal(fundingSource)" />
                    <label :for="fundingSource.id" />
                  </div>
                </td>
                <td class="text-left">
                  <span class="label" v-if="fundingSource.type !== fundingSourceTypes.CHECK.name && fundingSource.type !== fundingSourceTypes.WIRE_TRANSFER.name"
                  v-bind:class="fundingSource.status === 'verified' ? 'label-success' : 'label-warning'">
                    {{fundingSource.status}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile Card View -->
        <div v-if="fundingSources.length > 0" class="mobile-card-view">
          <div class="funding-cards">
            <div 
              v-for="(fundingSource, index) in fundingSources" 
              :key="index"
              class="funding-card"
            >
              <div class="funding-card-header">
                <div class="funding-card-icon">
                  <i class="fa fa-university"></i>
                </div>
                <div class="funding-card-title">
                  {{fundingSource.bankName ? fundingSource.bankName : '-----'}}
                </div>
                <span 
                  v-if="fundingSource.type !== fundingSourceTypes.CHECK.name && fundingSource.type !== fundingSourceTypes.WIRE_TRANSFER.name"
                  class="label funding-card-status" 
                  v-bind:class="fundingSource.status === 'verified' ? 'label-success' : 'label-warning'">
                  {{fundingSource.status}}
                </span>
              </div>
              
              <div class="funding-card-body">
                <div class="funding-card-row">
                  <span class="funding-card-label">Account name:</span>
                  <span class="funding-card-value">{{fundingSource.name}}</span>
                </div>
                
                <div class="funding-card-row">
                  <span class="funding-card-label">Type:</span>
                  <span class="funding-card-value">{{formatType(fundingSource.type, 'investor')}}</span>
                </div>

                <div v-if="fundingSource.status === 'verified'" class="funding-card-row funding-card-default">
                  <span class="funding-card-label">Set as default:</span>
                  <div class="funding-card-radio">
                    <div :class="{ 'radio-item-mobile': true, 'radio-item-selected': fundingSource.id.toString() === currentDefaultFundingSourceId }">
                      <input 
                        type="radio"
                        :id="`mobile-${fundingSource.id}`"
                        :value="fundingSource.id.toString()"
                        :checked="fundingSource.id.toString() === currentDefaultFundingSourceId"
                        @click="showDefaultFundingSourceConfirmationModal(fundingSource)" 
                      />
                      <label :for="`mobile-${fundingSource.id}`">
                        {{ fundingSource.id.toString() === currentDefaultFundingSourceId ? 'Default account' : 'Make default' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="modal">
        <div class="modal-overlay" v-if="showDwollaComponent" style="opacity: 1.09; display: block;">
          <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="false" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">
            <div class="modal-close col-sm-12 text-right">
              <button class="modal-button" @click="closeDwollaModal"><span class="icon-close"></span></button>
            </div>

            <header class="modal-header">
              <h2 class="modal-title">Add bank account</h2>
            </header>

            <div class="modal-body mt-lg">
              <dwolla-funding-source-create
                :customerId="account.dwollaCustomerId || currentDwollaCustomerIdFromStore"
                initiateMicroDeposits>
              </dwolla-funding-source-create>
            </div>

            <div class="modal-buttons" v-if="showDwollaAcknowledgeButton">
              <div class="row">
                <div class="col-md-12 text-right">
                  <button type="button" class="btn btn-info btn-lg btn-cancel" @click="acknowledgeDwollaMessage">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import {
    HIDE_QUESTION_MODAL,
    SHOW_CHECK_WIRE_MODAL,
    SHOW_QUESTION_MODAL,
  } from '@/store/mutation-types';

  import { Constants } from '@/data/static/constants';
  import { Events } from '@/data/static/events';
  import CheckWire from '@/components/modals/CheckWireTransfer';
  import { env } from '@/config/config';
  import TransactionTypes from '@/data/static/transactionTypes';
  import TransactionStatuses from '@/data/static/transactionStatuses';

  import {
    formatType,
  } from '@/util';

  const mix = {
    methods: {
      formatType,
    },
  };

  export default {
    name: 'AccountFundingSources',
    created() {
      this.configureDwolla();
    },
    beforeMount() {
      this.currentDefaultFundingSourceId = this.defaultFundingSourceId;
      console.log('**this.account**', this.account);
    },
    mounted() {
      this.initialize();
    },
    components: {
      CheckWire,
    },
    computed: {
      ...mapState('app', [
        'fundingSourceTypes',
      ]),
      ...mapState('checkWireModal', [
        'isCheckWireModalVisible',
        'creationSucceeded',
      ]),
      ...mapState('home', [
        'userStatus',
      ]),
      ...mapState('fundingSource', [
        'currentDwollaCustomerId',
      ]),
      currentDwollaCustomerIdFromStore() {
        return this.currentDwollaCustomerId;
      },
    },
    data() {
      return {
        currentDefaultFundingSourceId: '',
        fundingSources: [],
        showFundingTable: true,
        dwollaService: window.dwolla,
        showDwollaComponent: false,
        showDwollaAcknowledgeButton: false,
      };
    },
    watch: {
      defaultFundingSourceId(val) {
        this.currentDefaultFundingSourceId = val;
        this.initialize();
      },
    },
    methods: {
      ...mapActions('account', [
        'getAccountFundingSources',
        'setDefaultFundingSource',
        'getAccountTransactions',
      ]),
      ...mapActions('fundingSource', [
        'getToken',
        'createDwollaUser',
        'getClientToken',
      ]),
      ...mapActions('accountCreation', [
        'getUserDetail',
      ]),
      ...mapMutations('checkWireModal', {
        showCheckWireModal: SHOW_CHECK_WIRE_MODAL,
      }),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('fundingSource', {
        setCurrentDwollaCustomerId: 'SET_CURRENT_DWOLLA_CUSTOMER_ID',
      }),
      getDwollaToken(request) {
        const effectiveCustomerId = this.account.dwollaCustomerId
          || this.currentDwollaCustomerIdFromStore;
        const payload = { ...request, dwollaCustomerId: effectiveCustomerId };
        return this.$store.dispatch('fundingSource/getClientToken', payload);
      },
      configureDwolla() {
        this.dwollaService.configure({
          environment: env === 'production' ? 'production' : 'sandbox',
          styles: 'static/dwolla-dropins.css',
          token: req => this.getDwollaToken(req),
          success: (res) => {
            console.log('Dwolla success:', res);
            // Keep modal visible for the user to read Dwolla's message; reveal Ok button
            this.showDwollaAcknowledgeButton = true;
          },
          error: (err) => {
            console.error('Dwolla error:', err);
            // Keep modal visible for the user to read Dwolla's message; reveal Ok button
            this.showDwollaAcknowledgeButton = true;
          },
        });
      },
      async initialize() {
        this.$emit(Events.FUNDING_SOURCES_LOADING_STARTED);
        const fundingSources = await this.getAccountFundingSources(this.accountId);

        this.fundingSources = fundingSources.filter(fss => !fss.removed &&
          (fss.type === this.fundingSourceTypes.BANK.name ||
          fss.type === this.fundingSourceTypes.CHECK.name ||
          fss.type === this.fundingSourceTypes.WIRE_TRANSFER.name));

        this.$emit(Events.FUNDING_SOURCES_LOADING_SUCCEED);
      },
      async methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
        try {
          this.hideQuestionModal();
          this.$emit(Events.FUNDING_SOURCES_LOADING_STARTED);

          await this.setDefaultFundingSource({
            accountId: this.accountId,
            fundingSourceId,
          });

          this.currentDefaultFundingSourceId = fundingSourceId.toString();
  
          // Check for upcoming transactions with destinations set
          await this.checkForUpcomingTransactions();

          await this.initialize();
          this.$emit(Events.DEFAULT_FUNDING_SOURCE_UPDATED);
        } catch (error) {
          this.$emit(Events.FUNDING_SOURCES_LOADING_FAILED);
        }
      },
      async checkForUpcomingTransactions() {
        try {
          const accountTransactions = await this.getAccountTransactions({
            accountId: this.accountId,
            params: {
              transactionTypes: [
                TransactionTypes.SELL_REINVEST,
                TransactionTypes.SELL_DONATE,
                TransactionTypes.SELL_MATURE,
                TransactionTypes.INT_REINVEST,
                TransactionTypes.INT_PAID,
                TransactionTypes.INT_DONATE,
              ],
              statuses: [TransactionStatuses.PREPENDING],
            },
          });

          // If there are upcoming transactions, emit event to show warning
          if (accountTransactions && accountTransactions.length > 0) {
            this.$emit('showBankAccountChangedWarning');
          }
        } catch (error) {
          console.error('Failed to check for upcoming transactions:', error);
          // Don't fail the whole operation if checking transactions fails
        }
      },
      getDwollaOptions() {
        return {
          container: 'verifyContainer',
          stylesheets: [
            'https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext',
          ],
          microDeposits: true,
          fallbackToMicroDeposits: true,
          backButton: true,
          subscriber: ({ currentPage }) => {
            if (currentPage === 'SuccessIAV') {
              this.checkUserStatus();
            }
          },
        };
      },
      createNewFundingSource(token) {
        const dwollaOptions = this.getDwollaOptions();
        return this.dwollaService.iav.start(token, dwollaOptions, (err, res) => {
          if (err) {
            return this.showErrorModal('Something went wrong please try again!');
          }
          return this.loadFundingSources().then((fundingSources) => {
            const fundingSourceIdAdded =
              this.getFundingSourceId(res._links); // eslint-disable-line no-underscore-dangle
            return this.loadUserProfile().then(() => {
              this.selectDefaultFundingSource(fundingSources, fundingSourceIdAdded);
            });
          });
        });
      },
      async addAccount() {
        // Ensure Dwolla customer exists for this account's primary investor
        if (!this.account.dwollaCustomerId) {
          try {
            await this.createDwollaUser(this.account.primaryInvestorId);
            // Refresh user to obtain the newly created Dwolla customer id
            const user = await this.getUserDetail(this.account.primaryInvestorId);
            const refreshedAccount = (user && user.accounts)
              ? user.accounts.find(acct => acct.id === this.accountId)
              : null;
            const newCustomerId = refreshedAccount && refreshedAccount.dwollaCustomerId;
            if (newCustomerId) {
              this.setCurrentDwollaCustomerId(newCustomerId);
            }
            // Inform parent to refresh its data as well
            this.$emit(Events.RESTART);
          } catch (e) {
            console.error('Failed to create Dwolla customer for user', e);
            return;
          }
        } else {
          this.setCurrentDwollaCustomerId(this.account.dwollaCustomerId);
        }
        this.showDwollaComponent = true;
      },
      modalToAddNewFundingSourceHasBeenClosed() {
        if (this.creationSucceeded) {
          this.initialize();
        }
      },
      openModal() {
        this.$emit(Events.OPEN_MODAL_TO_ADD_NEW_FUNDING_SOURCE);
      },
      openModalToAddNewFundingSource() {
        const filteredFundingSources = this.fundingSources.filter(fundingSource =>
            fundingSource.type === this.fundingSourceTypes.CHECK.name ||
            fundingSource.type === this.fundingSourceTypes.WIRE_TRANSFER.name);

        this.showCheckWireModal({
          accountId: this.accountId,
          fundingSources: filteredFundingSources,
        });
      },
      showDefaultFundingSourceConfirmationModal({ id, name }) {
        this.showQuestionModal({
          title: 'Bank account',
          question: `Are you sure you want to select ${name} as new default bank account?`,
          method: () => {
            this.methodToExecuteInDefaultFundingSourceQuestionModal(id);
          },
          yesButtonText: Constants.purchaseNote.modalYesButtonText,
          hideCancelButton: false,
        });
      },
      closeDwollaModal() {
        this.showDwollaComponent = false;
      },
      async acknowledgeDwollaMessage() {
        // User has read the Dwolla message; now refresh and close
        this.showDwollaAcknowledgeButton = false;
        try {
          await this.initialize();
          this.$emit(Events.RESTART);
        } catch (err) {
          console.error('Failed to refresh funding sources after acknowledgement', err);
        } finally {
          this.showDwollaComponent = false;
        }
      },
    },
    mixins: [mix],
    props: ['accountId', 'defaultFundingSourceId', 'account'],
  };
</script>

<style scoped>
  .panel-title {
    font-size: 20px;
    margin-bottom: 5px;
  }
  .btn-trash {
    border: 1px solid #DCE0E5;
  }
  .delete-icon {
    color: #f05050;
  }
  .radio-item {
    height: 25px;
    padding: 0;
  }
  .radio-item label {
    color: #666;	    color: #666;
    font-weight: normal;
    padding-left: 25px;
    padding-top: 5px;
    cursor: pointer;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: absolute;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item label:after {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 0;
    content: "";
    display: block;
    background-color: #127285;
    margin-left: 5px;
  }
  .radio-item.radio-item-unselected label:after {
    display: none;
  }
  table {
    border-collapse: collapse;
  }
  th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }
  td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
    height: 60px;
  }
  .table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }
  .panel-title {
    font-size: 20px;
  }
  .panel-default {
    padding: 30px 40px;
  }
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  /* Mobile card view - hidden on desktop */
  .mobile-card-view {
    display: none;
  }

  /* Desktop table view - visible by default */
  .desktop-table {
    display: block;
  }

  /* Mobile responsive styles */
  @media (max-width: 1024px) {
    /* Hide desktop table, show mobile cards */
    .desktop-table {
      display: none !important;
    }

    .mobile-card-view {
      display: block;
      margin-top: 20px;
    }

    .panel-title {
      font-size: 22px !important;
      padding: 0 20px;
    }

    .panel-default {
      padding: 20px 0 !important;
    }

    .line-separator {
      margin: 0 20px;
    }

    /* Button row responsive */
    .button-row {
      padding: 0 20px;
      margin-bottom: 20px !important;
    }

    .button-col {
      width: 100% !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-bottom: 12px;
    }

    .button-col .btn {
      width: 100%;
      font-size: 17px !important;
      padding: 14px 20px !important;
      margin-top: 0 !important;
    }

    /* Alert responsive */
    .alert {
      margin: 0 20px 20px 20px !important;
      font-size: 16px !important;
    }

    /* Card styles */
    .funding-cards {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .funding-card {
      background-color: #fff;
      border-bottom: 1px solid #eee;
      padding: 20px;
      transition: background-color 0.2s;
    }

    .funding-card:nth-child(odd) {
      background-color: #fafbfc;
    }

    .funding-card-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e8e8e8;
    }

    .funding-card-icon {
      flex-shrink: 0;
      margin-right: 12px;
      font-size: 24px;
      color: #00788d;
    }

    .funding-card-title {
      flex: 1;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      word-break: break-word;
    }

    .funding-card-status {
      flex-shrink: 0;
      margin-left: 12px;
      font-size: 13px;
      padding: 4px 10px;
    }

    .funding-card-body {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }

    .funding-card-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
    }

    .funding-card-default {
      padding-top: 8px;
      margin-top: 6px;
      border-top: 1px solid #f0f0f0;
    }

    .funding-card-label {
      font-size: 15px;
      color: #888;
      flex-shrink: 0;
      min-width: 110px;
    }

    .funding-card-value {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      text-align: right;
      word-break: break-word;
    }

    .funding-card-radio {
      display: flex;
      align-items: center;
    }

    .radio-item-mobile {
      position: relative;
      display: inline-flex;
      align-items: center;
    }

    .radio-item-mobile input[type="radio"] {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    .radio-item-mobile label {
      cursor: pointer;
      padding-left: 32px;
      font-size: 15px;
      color: #127285;
      font-weight: 500;
      position: relative;
      margin: 0;
    }

    .radio-item-mobile label:before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 22px;
      height: 22px;
      border: 2px solid #d3d3d3;
      border-radius: 50%;
      background-color: #fff;
    }

    .radio-item-mobile.radio-item-selected label:before {
      border-color: #127285;
    }

    .radio-item-mobile label:after {
      content: "";
      position: absolute;
      left: 6px;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #127285;
      display: none;
    }

    .radio-item-mobile.radio-item-selected label:after {
      display: block;
    }
  }

  @media (max-width: 480px) {
    .panel-title {
      font-size: 20px !important;
      padding: 0 16px;
    }

    .panel-default {
      padding: 18px 0 !important;
    }

    .line-separator {
      margin: 0 16px;
    }

    .button-row {
      padding: 0 16px;
    }

    .button-col .btn {
      font-size: 16px !important;
      padding: 13px 18px !important;
    }

    .alert {
      margin: 0 16px 18px 16px !important;
      font-size: 15px !important;
    }

    .funding-card {
      padding: 18px 16px;
    }

    .funding-card-icon {
      font-size: 22px;
      margin-right: 10px;
    }

    .funding-card-title {
      font-size: 17px;
    }

    .funding-card-status {
      font-size: 12px;
      padding: 3px 8px;
    }

    .funding-card-label {
      font-size: 14px;
      min-width: 100px;
    }

    .funding-card-value {
      font-size: 15px;
    }

    .radio-item-mobile label {
      font-size: 14px;
      padding-left: 30px;
    }

    .radio-item-mobile label:before {
      width: 20px;
      height: 20px;
    }

    .radio-item-mobile label:after {
      left: 5px;
      width: 10px;
      height: 10px;
    }
  }

  @media (max-width: 360px) {
    .panel-title {
      font-size: 18px !important;
      padding: 0 14px;
    }

    .panel-default {
      padding: 16px 0 !important;
    }

    .line-separator {
      margin: 0 14px;
    }

    .button-row {
      padding: 0 14px;
    }

    .button-col .btn {
      font-size: 15px !important;
      padding: 12px 16px !important;
    }

    .alert {
      margin: 0 14px 16px 14px !important;
      font-size: 14px !important;
    }

    .funding-card {
      padding: 16px 14px;
    }

    .funding-card-icon {
      font-size: 20px;
    }

    .funding-card-title {
      font-size: 16px;
    }

    .funding-card-label {
      font-size: 13px;
      min-width: 90px;
    }

    .funding-card-value {
      font-size: 14px;
    }

    .radio-item-mobile label {
      font-size: 13px;
      padding-left: 28px;
    }

    .radio-item-mobile label:before {
      width: 18px;
      height: 18px;
    }

    .radio-item-mobile label:after {
      left: 4px;
      width: 10px;
      height: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// AccountFundingSources.vue?183d8701